import type { ReactNode } from 'react';
import styles from './screen.module.css';

type ScreenProps = {
  children: ReactNode;
};

export const Screen = ({ children }: ScreenProps) => (
  <main className={styles.screen}>{children}</main>
);
